/* eslint-disable max-len */
export const handleZipCodeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  let zipCodeValue = e.target.value.replace(/[^0-9-]/g, "");
  const hasDash = zipCodeValue.includes("-");

  if (!hasDash && zipCodeValue.length > 5) {
    zipCodeValue = zipCodeValue.slice(0, 5) + "-" + zipCodeValue.slice(5);
  }

  const parts = zipCodeValue.split("-");

  if (parts[0].length < 5 && parts[1] && parts[1].length > 4) {
    zipCodeValue = `${parts[0]}-${parts[1].slice(0, 4)}`;
  } else if (parts[0].length === 5 && parts[1] && parts[1].length > 4) {
    zipCodeValue = `${parts[0]}-${parts[1].slice(0, 4)}`;
  } else if (parts[0].length > 5) {
    zipCodeValue = parts[0].slice(0, 5);
  }

  if (hasDash && parts[0].length < 5) {
    zipCodeValue = zipCodeValue.replace("-", "");
  }

  if (zipCodeValue.split("-").length > 2) {
    const [firstPart, ...restParts] = zipCodeValue.split("-");

    zipCodeValue = firstPart + "-" + restParts.join("");
  }

  e.target.value = zipCodeValue;
};


